import { ActionContext } from "vuex";
import { SessionState } from "@/store/session/state";
import { RootState } from "@/store/types";

/**
 * @param context - Context where the action is being taking place.
 * @param args - Partial session state to update the session
 */
export async function storeSession(
  context: ActionContext<SessionState, RootState>,
  args: Partial<SessionState>
): Promise<void> {
  if (args.sessionUrl) context.commit("setSessionUrl", args.sessionUrl);
  if ("isSidebarCollapsed" in args)
    context.commit("setIsSidebarCollapsed", args.isSidebarCollapsed);
  const encodedSession = context.getters["getEncodedSessionObject"];
  localStorage.setItem("session", encodedSession);
}
